import { useState } from "react";
import { toast } from "sonner";
import { adminApi, errText } from "./api";
import { Field, SaveBtn, Panel } from "./Fields";

export const PasswordForm = () => {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await adminApi.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Şifre güncellendi");
      setCur("");
      setNext("");
    } catch (ex) {
      toast.error(errText(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={save} className="max-w-md" data-testid="admin-password-form">
      <Panel className="space-y-4">
        <Field id="cur-pass" type="password" label="Mevcut şifre" value={cur} required onChange={(e) => setCur(e.target.value)} data-testid="admin-current-password" />
        <Field id="new-pass" type="password" label="Yeni şifre (en az 6 karakter)" minLength={6} value={next} required onChange={(e) => setNext(e.target.value)} data-testid="admin-new-password" />
        <SaveBtn busy={busy} data-testid="admin-password-save">Şifreyi Değiştir</SaveBtn>
      </Panel>
    </form>
  );
};
